import {
  Button,
  makeStyles,
  Typography,
  Paper,
  OutlinedInput,
  useTheme,
  Box,
  Table,
  TableRow,
  TableCell,
  Grid,
} from "@material-ui/core";
import React, { useEffect, forwardRef } from "react";
import { Link } from "react-router-dom";
import MaterialTable from "material-table";
import { useDispatch } from "react-redux";
import { MdDelete } from "react-icons/md";
import {
  AddBox,
  FirstPage,
  LastPage,
  ChevronLeft,
  ChevronRight,
  Search,
  ArrowDownward,
  Clear,
  Check,
  Edit,
  Delete,
  SaveAlt,
  FilterList,
  Remove,
  ViewColumn,
  Add,
} from "@material-ui/icons";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    margin: "30px 0",
  },
  shopBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    minWidth: "110px",
    margin: "30px 0",
    fontSize: "16px",
    height: "100%",
    fontWeight: "600",
    borderRadius: "2px",
    padding: "10px 10px",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
  sectionHeading: {
    fontSize: "36px",
    fontWeight: "600",
  },
  couponField: {
    padding: "10px",
    borderRadius: "2px",
    height: "100%",
    margin: "0 5px 0 0",
  },
}));

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <Delete {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

function CartTable(props) {
  const classes = useStyles();
  const theme = useTheme();
  const { cart, updateCart } = props;
  const dispatch = useDispatch();
  const [tableData, setTableData] = useState(cart);
  const [total, setTotal] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [finalCost, setFinalCost] = useState(0);
  const toastOptions = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
  };
  const openToast = () => {
    toast.success("Cart Updated", toastOptions);
  };

  useEffect(() => {
    // console.log({'Cart in Table': cart})
    // console.log({Table: tableData})
    setTotal(0);
    setDiscount(0);
  }, [tableData]);

  useEffect(() => {
    handlePriceCalculation();
  }, [cart]);

  const updateTable = (newValue, index) => {
    // console.log('In Update'+ newValue + index)
    let newData = [...tableData];

    let newObject = { ...newData[index], quantity: newValue };
    newData[index] = newObject;
    // console.log({Table: newData[index]})
    setTableData(newData);
  };

  const handleItemDelete = (index) => {
    let newData = [...tableData];
    newData.splice(index, 1);
    setTableData(newData);
  };

  const handleCartUpdate = () => {
    if (tableData !== cart) {
      dispatch(updateCart(tableData));
      toast.success("Cart Updated", toastOptions);
    } else {
      toast.error("There is no Update Done in Cart", toastOptions);
    }
    handlePriceCalculation();
  };

  const handleCartReset = () => {
    if (tableData !== cart) {
      setTableData(cart);
      toast.success("Cart Reset", toastOptions);
    } else {
      toast.error("Cart is Same", toastOptions);
    }
    handlePriceCalculation();
  };

  const handlePriceCalculation = () => {
    setTotal(0);
    setDiscount(0);
    setFinalCost(0);
    cart.map((item) => {
      // console.log(total, item.price)
      setTotal(total + parseInt(item.price) * parseInt(item.quantity));
    });
    setFinalCost(parseInt(total) - parseInt(discount));
  };

  return (
    <div className={classes.root}>
      {cart.length > 0 ? (
        <>
          <MaterialTable
            icons={tableIcons}
            columns={[
              { title: "Book", field: "book", editable: "never" },
              { title: "Title", field: "title", editable: "never" },
              { title: "Price", field: "price", editable: "never" },
              { title: "Quantity", field: "quantity", type: "numeric" },
              { title: "Subtotal", field: "subtotal", editable: "never" },
            ]}
            options={{
              toolbar: false,
              paging: false,
              headerStyle: {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.secondary.light,
                fontWeight: 600,
                fontSize: 16,
              },
              rowStyle: {
                alignItems: "center",
              },
              actionsColumnIndex: -1,
            }}
            actions={[
              {
                icon: tableIcons.Delete,
                tooltip: "Delete Current Item",
                onClick: (event, rowData) => {
                  handleItemDelete(rowData.index);
                },
              },
            ]}
            data={tableData.map((item, index) => {
              return {
                book: <img src={item.cover} />,
                title: item.title,
                price: `$ ${item.price}`,
                index: index,
                quantity: item.quantity,
                subtotal: item.price * item.quantity,
                // quantity: <OutlinedInput type="number" value={item.quantity} fullWidth onChange={(e) => tableData[index].quantity=e.target.value} />
              };
            })}
            cellEditable={{
              onCellEditApproved: (newValue, oldValue, rowData, columnDef) => {
                return new Promise((resolve, reject) => {
                  console.log("newValue: " + newValue);
                  console.log(rowData.index);
                  updateTable(newValue, rowData.index);

                  setTimeout(resolve, 100);
                  console.log("Done");
                });
              },
            }}
          ></MaterialTable>
          <Box display="flex" justifyContent="space-between">
            <Button className={classes.shopBtn} onClick={handleCartReset}>
              RESET CART
            </Button>
            <Button className={classes.shopBtn} onClick={handleCartUpdate}>
              UPDATE CART
            </Button>
          </Box>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={6} textAlign="left">
              <h2 className={classes.sectionHeading}>Cart Totals</h2>
            </Grid>
            <Grid item xs={12} md={6} style={{ textAlign: "right" }}>
              <OutlinedInput type="text" className={classes.couponField} />
              <Button className={classes.shopBtn}>Apply Coupon</Button>
            </Grid>
          </Grid>
          <Table>
            <TableRow>
              <TableCell variant="head">Total</TableCell>
              <TableCell>{total}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell variant="head">Discount</TableCell>
              <TableCell>{discount}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell variant="head">Final</TableCell>
              <TableCell>{finalCost}</TableCell>
            </TableRow>
          </Table>
          <Link style={{ textDecoration: "none" }} to="/checkout">
            <Button className={classes.shopBtn}>Proceed to Checkout</Button>
          </Link>
        </>
      ) : (
        <div style={{ textAlign: "center" }}>
          <Typography variant="h5" color="error">
            Cart is Empty
          </Typography>
          <Link to="/shop" style={{ textDecorationLine: "none" }}>
            <Button className={classes.shopBtn}>View Shop</Button>
          </Link>
        </div>
      )}
    </div>
  );
}

export default CartTable;
